export enum MerchantProfileFields {
  FIRST_NAME = "firstName",
  LAST_NAME = "lastName",
  BVN = "bvn",
  DATE_OF_BIRTH = "dateOfBirth",
  ACCOUNT = "account",
  BUSINESS_NAME = "businessName",
  PHONE_NUMBER = "phoneNumber",
  PHONE_NUMBER_PREFIX = "phoneNumberPrefix",
  EMAIL = "email",
}

export enum EmployeeProfileFields {
  FIRST_NAME = "firstName",
  LAST_NAME = "lastName",
  PHONE_NUMBER = "phoneNumber",
  PHONE_NUMBER_PREFIX = "phoneNumberPrefix",
  EMAIL = "email",
}

export const MerchantOTPRequiredFields = [
  MerchantProfileFields.EMAIL,
  MerchantProfileFields.PHONE_NUMBER,
];

export const EmployeeOTPRequiredFields = [
  EmployeeProfileFields.EMAIL,
  EmployeeProfileFields.PHONE_NUMBER,
];

export type MerchantProfileForm = {
  [MerchantProfileFields.FIRST_NAME]: string;
  [MerchantProfileFields.LAST_NAME]: string;
  [MerchantProfileFields.BVN]: string;
  [MerchantProfileFields.DATE_OF_BIRTH]: string;
  [MerchantProfileFields.ACCOUNT]: string;
  [MerchantProfileFields.BUSINESS_NAME]: string;
  [MerchantProfileFields.PHONE_NUMBER]: string;
  [MerchantProfileFields.PHONE_NUMBER_PREFIX]: string;
  [MerchantProfileFields.EMAIL]: string;
};

export type EmployeeProfileForm = {
  [EmployeeProfileFields.FIRST_NAME]: string;
  [EmployeeProfileFields.LAST_NAME]: string;
  [EmployeeProfileFields.PHONE_NUMBER]: string;
  [EmployeeProfileFields.PHONE_NUMBER_PREFIX]: string;
  [EmployeeProfileFields.EMAIL]: string;
};

export type ErrorField = {
  message: string;
  hasError: boolean;
};

export type MerchantProfileFormValidation = {
  [key in keyof MerchantProfileForm]?: ErrorField;
};

export type EmployeeProfileFormValidation = {
  [key in keyof EmployeeProfileForm]?: ErrorField;
};
